<div class="grey-M" [dir]="textDir">
  <div class="loading" *ngIf="!loaded"></div>
  <div>
    <label class="form-title">2. {{'Assign subjects' | translate}}</label>
    <label class="label-light">{{schoolDetails.name}}</label>
</div>
    <div class="marT15"><label class="labeltxt" *ngIf="!nextBtnClicked" >{{'Please assign the subjects required' | translate}}</label>
    
      <label class="labeltxt" *ngIf="nextBtnClicked">{{'Is this correct' | translate}}</label>
    </div>
      <div class="row marT10 marB10 ">
        <div class="md-3" ><label class="label-light-opa marT5">{{'School grade' | translate}}</label></div>
        <div class="md-3"><label class="label-light-opa marT5">{{'Classes' | translate}}</label></div>
        <div class="md-6"><label class="label-light-opa marT5">{{'Subjects' | translate}}</label></div>
    </div>
    <div>
    

    <div style="overflow-y:auto; max-height:300px;overflow-x: hidden;">
      <div *ngFor="let grade of this.gradeList; let i = index">
        <div class="row " >
            <div class="md-3">
                <label class="labeltxt marT5">{{grade?.name}}</label>
            </div>
            <div class="md-3">
                <label class="labeltxt marT5">{{grade?.classes|ctlJoin}}</label>
            </div>
            <div class="md-6">
              <label class="labeltxt marT5" *ngIf="!nextBtnClicked">
                <a style="cursor: pointer;" class="font12" (click)="currentSelectedGrade(grade)">
                  <ng-container *ngIf="!grade?.subjects?.length">
                    ({{'Assign subjects' | translate}})
                  </ng-container>
                  <ng-container *ngIf="grade?.subjects?.length">
                    <span>{{grade?.subjects|ctlJoin}}</span>
                  </ng-container>
                </a>
              </label>

              <label class="labeltxt marT5" *ngIf="nextBtnClicked">
                
                  <ng-container *ngIf="grade?.subjects?.length">
                    <span>{{grade?.subjects|ctlJoin}}</span>
                  </ng-container>
               
              </label>
            </div>
          </div>
         
        </div>
      </div>
    </div>
</div>
